import React from 'react'

export default function NotFoundPage() {
  return (
    <div>
      <h2>Page not found...</h2>
    </div>
  )
}
